// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"5d44c84891d4bf9386ce","731":"50a6dabafe7d779dd9de","843":"4d22e4d87d98fa226c97","883":"3bae62a1b25f47f3bf7d"}[chunkId] + ".js";
};